module.exports = __webpack_public_path__ + "static/media/google5.21b37399.png";